import UserModel from 'src/models/UserModel';
import { FeatureName } from '@invoice-simple/feature-gate';

export const isAllowedReports = (user: UserModel) => {
  const hasFullAccess = user.canUseFeature(FeatureName.REPORTS);
  const isMobileOnly = user.hasMobileOnlySub;

  return hasFullAccess || isMobileOnly;
};
